<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-2 pb-0">
                    <v-col lg="4" md="6" cols="12">
                      <v-autocomplete
                        label="Product (Required)"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="product_id.value.value"
                        :items="getProductMapList"
                        :item-title="(item) => item.product ? `${item.product.name || ''} ${item.product.product_code ? '(' + item.product.product_code + ')' : ''}`.trim() : ''"
                        item-value="product_id"
                        :error-messages="product_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                        @update:model-value="loadBatches"
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="4" md="6" cols="12">
                      <v-autocomplete
                        label="Warehouse"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="warehouse_id.value.value"
                        :items="getWarehouseList"
                        :item-title="(item) => `${item.name}`"
                        item-value="id"
                        :error-messages="warehouse_id.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="4" md="12" cols="12">
                      <v-autocomplete
                        label="Batch No"
                        variant="outlined"
                        density="compact"
                        bg-color="grey-lighten-4"
                        v-model="batch_no.value.value"
                        :items="getInventoryBatchList"
                        :item-title="(item) => `${item.batch_no}`"
                        item-value="batch_no"
                        :error-messages="batch_no.errorMessage.value"
                        autocomplete="off"
                        clearable
                        :disabled="!product_id.value.value"
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-row class="px-2 pt-0 pb-2" style="margin-top: -12px;">
                    <v-col lg="3" md="6" cols="12">
                      <v-date-input
                        v-model="from_date.value.value"
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-start"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="3" md="6" cols="12">
                      <v-date-input
                        v-model="to_date.value.value"
                        label="To Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-calendar-end"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="6" md="12" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        ref="searchButton"
                        :disabled="!product_id.value.value"
                        >Search</v-btn
                      >
                      <v-btn
                        class="bg-orange w-15 ml-2"
                        @click="resetFilters"
                        >Reset</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Inventory Details List (Transaction Log)</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right pr-2">
                      <v-chip color="primary" variant="tonal">
                        Total Transactions: {{ getSchema.length }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:no-data>
                    <v-alert type="info" class="ma-2">
                      Please select a product and click Search to view inventory transaction details
                    </v-alert>
                  </template>
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.type="{ item }">
                    <v-chip
                      :color="item.type === 'In' ? 'success' : 'error'"
                      size="small"
                    >
                      {{ item.type }}
                    </v-chip>
                  </template>

                  <template v-slot:item.batch_no="{ item }">
                    <v-chip size="small" color="info" variant="tonal">
                      {{ item.batch_no }}
                    </v-chip>
                  </template>

                  <template v-slot:item.warehouse="{ item }">
                    {{ item.warehouse?.name || "N/A" }}
                  </template>

                  <template v-slot:item.product_code="{ item }">
                    <span class="font-weight-medium">{{
                      item.product?.product_code || "N/A"
                    }}</span>
                  </template>

                  <template v-slot:item.barcode="{ item }">
                    {{ item.product?.barcode || "N/A" }}
                  </template>

                  <template v-slot:item.product_name="{ item }">
                    {{ item.product?.name || "N/A" }}
                  </template>

                  <template v-slot:item.category="{ item }">
                    {{ item.product?.category?.name || "N/A" }}
                  </template>

                  <template v-slot:item.brand="{ item }">
                    {{ item.product?.brand?.name || "N/A" }}
                  </template>

                  <template v-slot:item.quantity="{ item }">
                    <span class="font-weight-medium">{{ item.quantity }}</span>
                  </template>

                  <template v-slot:item.purchase_unit_price="{ item }">
                    {{ formatCurrency(item.purchase_unit_price) }}
                  </template>

                  <template v-slot:item.sales_unit_price="{ item }">
                    {{ formatCurrency(item.sales_unit_price) }}
                  </template>

                  <template v-slot:item.orderable_type="{ item }">
                    <v-chip size="small" variant="tonal">
                      {{ formatOrderableType(item.orderable_type) }}
                    </v-chip>
                  </template>

                  <template v-slot:item.created_at="{ item }">
                    {{ formatDateTime(item.created_at) }}
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";

export default {
  components: {},
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    headers: [
      {
        title: "#SL",
        align: "center",
        key: "index",
        width: "80px",
        sortable: false,
      },
      {
        title: "Type",
        key: "type",
        align: "center",
        sortable: true,
        width: "100px",
      },
      {
        title: "Batch No",
        key: "batch_no",
        align: "left",
        sortable: true,
        width: "180px",
      },
      {
        title: "Warehouse",
        align: "left",
        key: "warehouse",
        sortable: true,
        width: "150px",
      },
      {
        title: "Product Code",
        align: "left",
        key: "product_code",
        sortable: true,
        width: "130px",
      },
      {
        title: "Product Barcode",
        align: "left",
        key: "barcode",
        sortable: true,
        width: "150px",
      },
      {
        title: "Product Name",
        align: "left",
        key: "product_name",
        sortable: true,
      },
      {
        title: "Category",
        align: "left",
        key: "category",
        sortable: true,
        width: "130px",
      },
      {
        title: "Brand",
        align: "left",
        key: "brand",
        sortable: true,
        width: "120px",
      },
      {
        title: "Quantity",
        align: "right",
        key: "quantity",
        sortable: true,
        width: "110px",
      },
      {
        title: "Purchase Rate",
        align: "right",
        key: "purchase_unit_price",
        sortable: true,
        width: "130px",
      },
      {
        title: "Sales Rate",
        align: "right",
        key: "sales_unit_price",
        sortable: true,
        width: "120px",
      },
      {
        title: "Transaction Type",
        align: "center",
        key: "orderable_type",
        sortable: true,
        width: "150px",
      },
      {
        title: "Transaction Date",
        align: "center",
        key: "created_at",
        sortable: true,
        width: "150px",
      },
    ],
  }),
  watch: {},
  created() {
    if (this.$store.getters.getWarehouseList.length === 0) {
      this.$store.dispatch("getWarehouseList");
    }

    if (this.$store.getters.getProductMapList.length === 0) {
      this.$store.dispatch("getProductMapList");
    }
  },
  computed: {
    getSchema() {
      return this.$store.getters.getInventoryDetailsList || [];
    },
    getWarehouseList() {
      return this.$store.getters.getWarehouseList || [];
    },
    branchId() {
      return this.$store.getters.getAuthUser.branch_id || null;
    },
    getProductMapList() {
      let products = this.$store.getters.getProductMapList;
      return products.filter(
        (item) => item.branch_id == this.branchId && item.status == 1
      );
    },
    getInventoryBatchList() {
      return this.$store.getters.getInventoryBatchList || [];
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        product_id: yup
          .number()
          .positive()
          .integer()
          .required()
          .label("Product"),
        warehouse_id: yup
          .number()
          .positive()
          .integer()
          .nullable()
          .label("Warehouse"),
        batch_no: yup.string().nullable().label("Batch No"),
        from_date: yup.string().nullable().label("From Date"),
        to_date: yup.string().nullable().label("To Date"),
      }),
    });

    const product_id = useField("product_id");
    const warehouse_id = useField("warehouse_id");
    const batch_no = useField("batch_no");
    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref(false);
    const store = useStore();

    const loadBatches = (value) => {
      if (value) {
        store.dispatch("getInventoryBatchList", { product_id: value });
      } else {
        store.commit("UNSET_INVENTORY_BATCH_LIST");
      }
    };

    const submit = handleSubmit((values) => {
      loading.value = true;
      const params = {
        product_id: values.product_id,
      };

      if (values.warehouse_id) {
        params.warehouse_id = values.warehouse_id;
      }

      if (values.batch_no) {
        params.batch_no = values.batch_no;
      }

      if (values.from_date) {
        params.from_date = values.from_date;
      }

      if (values.to_date) {
        params.to_date = values.to_date;
      }

      store
        .dispatch("getInventoryDetailsList", params)
        .then((response) => {
          loading.value = false;
          toast.success("Inventory details loaded successfully", {
            autoClose: 3000,
          });
        })
        .catch((error) => {
          loading.value = false;
          toast.error(
            "Failed to load inventory details: " +
              (error.response?.data?.message || error.message),
            {
              autoClose: 5000,
            }
          );
        });
    });

    const resetFilters = () => {
      resetForm();
      store.commit("UNSET_INVENTORY_DETAILS_LIST");
      store.commit("UNSET_INVENTORY_BATCH_LIST");
    };

    return {
      product_id,
      warehouse_id,
      batch_no,
      from_date,
      to_date,
      submit,
      errorMessages,
      loading,
      loadBatches,
      resetFilters,
    };
  },
  methods: {
    formatCurrency(value) {
      if (!value) return "0.00";
      return parseFloat(value).toFixed(2);
    },

    formatDateTime(value) {
      if (!value) return "N/A";
      const date = new Date(value);
      return date.toLocaleString();
    },

    formatOrderableType(type) {
      if (!type) return "N/A";
      // Extract class name from namespaced path
      const parts = type.split("\\");
      return parts[parts.length - 1];
    },

    exportToPDF() {
      let serialNumber = 1;
      const columns = [
        "#SL",
        "Type",
        "Batch No",
        "Warehouse",
        "Product Code",
        "Product Barcode",
        "Product Name",
        "Category",
        "Brand",
        "Quantity",
        "Purchase Rate",
        "Sales Rate",
        "Transaction Type",
        "Transaction Date",
      ];
      const rows = this.getSchema.map((item) => [
        serialNumber++,
        item.type,
        item.batch_no,
        item.warehouse?.name || "N/A",
        item.product?.product_code || "N/A",
        item.product?.barcode || "N/A",
        item.product?.name || "N/A",
        item.product?.category?.name || "N/A",
        item.product?.brand?.name || "N/A",
        item.quantity,
        this.formatCurrency(item.purchase_unit_price),
        this.formatCurrency(item.sales_unit_price),
        this.formatOrderableType(item.orderable_type),
        this.formatDateTime(item.created_at),
      ]);
      this.$exportTableToPDF(
        columns,
        rows,
        "Inventory Details List",
        "inventory_details_" + this.$fileDate()
      );
    },

    exportToExcel() {
      var data = [
        [
          "#SL",
          "Type",
          "Batch No",
          "Warehouse",
          "Product Code",
          "Product Barcode",
          "Product Name",
          "Category",
          "Brand",
          "Quantity",
          "Purchase Rate",
          "Sales Rate",
          "Transaction Type",
          "Transaction Date",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.type,
          item.batch_no,
          item.warehouse?.name || "N/A",
          item.product?.product_code || "N/A",
          item.product?.barcode || "N/A",
          item.product?.name || "N/A",
          item.product?.category?.name || "N/A",
          item.product?.brand?.name || "N/A",
          item.quantity,
          this.formatCurrency(item.purchase_unit_price),
          this.formatCurrency(item.sales_unit_price),
          this.formatOrderableType(item.orderable_type),
          this.formatDateTime(item.created_at),
        ]);
      });
      this.$exportTableToExcel(
        data,
        "inventory_details_" + this.$fileDate()
      );
    },

    exportToCSV() {
      var data = [
        [
          "#SL",
          "Type",
          "Batch No",
          "Warehouse",
          "Product Code",
          "Product Barcode",
          "Product Name",
          "Category",
          "Brand",
          "Quantity",
          "Purchase Rate",
          "Sales Rate",
          "Transaction Type",
          "Transaction Date",
        ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([
          serialNumber++,
          item.type,
          item.batch_no,
          item.warehouse?.name || "N/A",
          item.product?.product_code || "N/A",
          item.product?.barcode || "N/A",
          item.product?.name || "N/A",
          item.product?.category?.name || "N/A",
          item.product?.brand?.name || "N/A",
          item.quantity,
          this.formatCurrency(item.purchase_unit_price),
          this.formatCurrency(item.sales_unit_price),
          this.formatOrderableType(item.orderable_type),
          this.formatDateTime(item.created_at),
        ]);
      });

      this.$exportTableToCSV(data, "inventory_details_" + this.$fileDate());
    },
  },
  mounted() {
    // Check if query parameters are present from navigation
    const { product_id, warehouse_id, batch_no, from_date, to_date } = this.$route.query;
    
    if (product_id) {
      // Set the form values from query parameters
      this.product_id.value.value = parseInt(product_id);
      
      if (warehouse_id) {
        this.warehouse_id.value.value = parseInt(warehouse_id);
      }
      
      if (batch_no) {
        // Load batches first for the selected product
        this.loadBatches(parseInt(product_id));
        
        // Wait a bit for batches to load, then set batch_no
        this.$nextTick(() => {
          setTimeout(() => {
            this.batch_no.value.value = batch_no;
          }, 500);
        });
      }

      if (from_date) {
        this.from_date.value.value = new Date(from_date + 'T00:00:00');
      }

      if (to_date) {
        this.to_date.value.value = new Date(to_date + 'T00:00:00');
      }
      
      // Automatically trigger the search
      this.$nextTick(() => {
        this.submit();
      });
    }
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}

.font-weight-medium {
  font-weight: 500;
}

.v-chip {
  font-weight: 500;
}
</style>

